import { render, staticRenderFns } from "./signDetail.vue?vue&type=template&id=73550d78&scoped=true&"
import script from "./signDetail.vue?vue&type=script&lang=ts&"
export * from "./signDetail.vue?vue&type=script&lang=ts&"
import style0 from "./signDetail.vue?vue&type=style&index=0&id=73550d78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73550d78",
  null
  
)

export default component.exports